// Shared parser used to turn fetched HTML responses into DOM trees.
let htmlParser = new DOMParser();
class PaginateLoadmore extends HTMLElement {
  constructor() {
    super();
    this.initLoadMore();
  }

  initLoadMore() {
    const count = document
      .getElementById("load-more-container")
      .getAttribute("data-count");
    this.querySelectorAll(".actions-load-more").forEach((loadMoreEl) => {
      var self = this;
      if (loadMoreEl.classList.contains("infinit-scrolling")) {
        // Infinite scroll: load the next page whenever the trigger is fully in view.
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach((entry) => {
              if (entry.intersectionRatio === 1) {
                self.loadMorePosts(loadMoreEl, count);
              }
            });
          },
          { threshold: 1.0 }
        );
        observer.observe(loadMoreEl);
      } else {
        // Manual: load the next page on click.
        loadMoreEl.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            const clickedButton = event.currentTarget;
            self.loadMorePosts(clickedButton, count);
          },
          false
        );
      }
    });
  }

  loadMorePosts(target, count) {
    const nextPageUrl = target.getAttribute("href");
    const self = this;
    self.toggleLoading(target, true);
    fetch(`${nextPageUrl}`)
      .then((response) => {
        if (!response.ok) {
          var responseError = new Error(response.status);
          throw responseError;
        }
        return response.text();
      })
      .then((responseText) => {
        // Parse the fetched page and append its items to the current list.
        const nextPageDoc = htmlParser.parseFromString(responseText, "text/html");
        const newItems = nextPageDoc.querySelectorAll(
          "#main-items .item-load"
        );
        newItems.forEach((itemNode) =>
          document
            .getElementById("section__content-items")
            .appendChild(itemNode)
        );

        // Promote lazy image data-srcset to srcset for the newly added items.
        const images = document.querySelectorAll("#section__content-items img");
        images.forEach((img) => {
          if (img.hasAttribute("data-srcset")) {
            img.setAttribute("srcset", img.getAttribute("data-srcset"));
            img.removeAttribute("data-srcset");
          }
        });

        const nextLoadMore = nextPageDoc.querySelector(".actions-load-more");
        document.querySelector(".load-more-amount").innerHTML =
          nextPageDoc.querySelector(".load-more-amount").textContent;
        if (nextLoadMore) {
          // Point the button at the following page, or remove it when done.
          target.setAttribute("href", nextLoadMore.getAttribute("href"));
        } else {
          target.remove();
        }
        self.updateProgressBar(count);
        self.toggleLoading(target, false);
      })
      .catch((error) => {
        throw error;
      });
  }

  // `element` is the load-more control whose "loading" class is toggled.
  toggleLoading(element, loading) {
    if (element) {
      const method = loading ? "add" : "remove";
      element.classList[method]("loading");
    }
  }

  updateProgressBar(count) {
    var loadedCount = document.querySelectorAll(
      "#section__content-items .item-load"
    ).length;
    var percent = (loadedCount / count) * 100;
    var progressBar = document.querySelector(".load-more-progress-bar");
    progressBar.style.setProperty("--percent", percent + "%");
    progressBar.style.setProperty("--amount", loadedCount);
  }
}

customElements.define("loadmore-button", PaginateLoadmore);

class LoadMoreButtonCollection extends HTMLElement {
  constructor() {
    super();
    this.loadMoreButton = this.querySelector("a");
    this.loadMoreElement = document.querySelector(".actions-load-more");
    this.init();
  }

  init() {
    if (!this.loadMoreButton) return;
    
    this.loadMoreButton.addEventListener("click", this.handleClick.bind(this));
    this.loadMoreButton.addEventListener("keydown", this.handleKeydown.bind(this));
  }

  handleClick(event) {
    event.preventDefault();
    this.executeLoadMore();
  }

  handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.executeLoadMore();
    }
  }

  executeLoadMore() {
    this.toggleLoading(true);
    
    setTimeout(() => {
      this.showHiddenCollections();
      this.toggleLoading(false);
      this.cleanup();
    }, 500);
  }

  toggleLoading(isLoading) {
    if (this.loadMoreElement) {
      this.loadMoreElement.classList.toggle("loading", isLoading);
    }
    
    if (this.loadMoreButton) {
      this.loadMoreButton.classList.toggle("loading", isLoading);
    }
  }

  showHiddenCollections() {
    const hiddenItems = document.querySelectorAll(
      ".section__collections-list .collection-item.hidden"
    );
    
    hiddenItems.forEach((item) => {
      item.classList.remove("hidden");
    });
  }

  cleanup() {
    this.remove();
  }
}

customElements.define("loadmore-button-collection", LoadMoreButtonCollection);
